import { CacheProvider } from './../cache/cache';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class UserClassProvider {

private cachePath = 'user';

  constructor(
      private cache: CacheProvider
  ) {
  }

    getCachePath()
    {
        return this.cachePath;
    }

    getCache(): Promise<any>
    {
        return new Promise((resolve, reject) => {
            this.cache.getCache(this.cachePath)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
        });
    }

    setCache(value): Promise<any>
    {
        return new Promise((resolve, reject) => {
            this.cache.setCache(this.cachePath, value)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/user-class/user-class.ts